import styled from 'styled-components'

export const FormContainer = styled.div`
    flex: 1;
    width: 100%;
    background-color: #fff;
`

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    /* background-color: red; */
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
`
